import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { DURATION, EASE } from '../../../shared/motion.js'


class AppLoader extends HTMLElement {
    constructor() {
        super()
        this.numEl = null

        // 動畫與 Split 實例快取
        this._split = null
        this._fadeOutAnimation = null
        this._hideAnimation = null
    }

    connectedCallback() {
        this._renderDOM()
        this._setupDOMReferences()
    }

    // ─────────────────────────────────────────────────────────────
    // DOM & Initialization Helpers
    // ─────────────────────────────────────────────────────────────

    _renderDOM() {
        this.innerHTML = /* html */ `<span class="loader__number">001</span>`
    }

    _setupDOMReferences() {
        this.numEl = this.querySelector('.loader__number')
    }

    _cleanupAnimations() {
        this._fadeOutAnimation?.kill()
        this._hideAnimation?.kill()
        this._split?.revert()

        this._split = null
        this._fadeOutAnimation = null
        this._hideAnimation = null
    }

    // ─────────────────────────────────────────────────────────────
    // Dynamic Updates (Progress)
    // ─────────────────────────────────────────────────────────────

    /** 更新進度數字 (0..1) */
    setProgress(value) {
        if (!this.numEl) {
            return
        }

        const percentage = Math.round(Math.max(0, Math.min(1, value)) * 100)
        this.numEl.textContent = String(percentage).padStart(3, '0')
    }

    // ─────────────────────────────────────────────────────────────
    // Motion Transitions
    // ─────────────────────────────────────────────────────────────

    /** 數字向上 Split 向上滑出 */
    fadeOut() {
        this._cleanupAnimations()

        if (!this.numEl) {
            return
        }

        // 呼叫當下 numEl 的文字已經是最終值（ramp 已跑完），直接進行 SplitText 拆解
        this._split = SplitText.create(this.numEl, { type: 'lines', mask: 'lines' })
        this._fadeOutAnimation = gsap.to(this._split.lines, {
            yPercent: -100,
            duration: DURATION.text,
            ease: EASE.in
        })

        const tl = gsap.timeline()
        tl.add(this._fadeOutAnimation, 0)
        return tl
    }

    /** Loader 背景淡出隱藏 */
    hide() {
        this._hideAnimation?.kill()

        this.style.pointerEvents = 'none'

        this._hideAnimation = gsap.to(this, {
            opacity: 0,
            duration: DURATION.spread,
            ease: EASE.out,
            onComplete: () => {
                this.style.display = 'none'
            }
        })

        const tl = gsap.timeline()
        tl.add(this._hideAnimation, 0)
        return tl
    }

    disconnectedCallback() {
        this._cleanupAnimations()
    }
}

if (!customElements.get('app-loader')) {
    customElements.define('app-loader', AppLoader)
}
